import { useEffect } from 'react';

import { DispatchAction } from '../actions';
import { ConsoleApiClient } from '../types';
import { State } from '../state';

const KIND = 'admin_event';
const SUBKIND = 'display_customer_images';
const METADATA = 'Display customer images reason';

export const useSubmitGdprLog = ({
  consoleApiClient,
  dispatch,
  state,
}: {
  consoleApiClient: ConsoleApiClient;
  dispatch: DispatchAction;
  state: State;
}) => {
  const postGdprLogState = state.applicationStatus === 'ready' ? state.postGdprLogState : undefined;

  useEffect(() => {
    if (postGdprLogState?.status === 'pending') {
      void consoleApiClient
        .postGdprLog(KIND, SUBKIND, METADATA, postGdprLogState.requestData.details, postGdprLogState.requestData.justification)
        .then((result) => {
          if (result.kind === 'success') {
            dispatch({ type: 'postGdprLogSuccess', payload: {} });
          } else {
            dispatch({ type: 'postGdprLogFailed', payload: {} });
          }
        });
    }
  }, [postGdprLogState, consoleApiClient, dispatch]);
};
